import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import * as breakpoints from '../../../data/breakpoints';
import siteStructure from '../../../data/siteStructure';
import MaxWidthContainer from '../Containers/MaxWidthContainer';
import IconWithText from '../Icons/IconWithText';
import Button from '../Buttons/Button';
import TileButton from '../Buttons/TileButton';

const TopLevelHero = ({ pageId, handleCreateClick }) => {
  const currentPage = siteStructure.find(item => item.id === pageId);
  const { id, title, iconName } = currentPage;
  const features = siteStructure.filter(item => item.parentId === id);
  const iconProps = { name: iconName, fill: `white` };
  const heading = <h1 className="like-h1 color-white m-b-0">{title}</h1>;
  const gridClass = `col-md-3 m-b-0 d-flex`;
  const btnClass = `flex-grow-1`;
  const linkClass = `link link--secondary fw-medium`;

  const iconWithText = (
    <MediaQuery minWidth={breakpoints.MEDIUM}>
      {(matches) => {
        if (matches) {
          return <IconWithText size="xl" {...iconProps}>{heading}</IconWithText>;
        }
        return <IconWithText size="l" {...iconProps}>{heading}</IconWithText>;
      }}
    </MediaQuery>
  );

  return (
    <div className="top-level-hero hero hero--m p-b-0 bg-green">
      <MaxWidthContainer classes="top-level-hero__overlap">
        <div className="top-level-hero__title">
          {iconWithText}
        </div>

        <MediaQuery minWidth={breakpoints.MEDIUM}>
          {(matches) => {
            if (matches) {
              return (
                <ul className="row list-row">
                  {features.map((feature) => {
                    const { href, iconFill, description } = feature;

                    return (
                      <li key={feature.id} className={gridClass}>
                        <TileButton
                          title={feature.title}
                          text={description}
                          iconName={feature.iconName}
                          iconFill={iconFill}
                          onClick={() => handleCreateClick(feature.id, href)}
                          classes={btnClass}
                        />
                      </li>
                    );
                  })}
                </ul>
              );
            }

            return (
              <div className="bg-white border-radius-l box-shadow-l border-bottom-4 border-color-green p-t-3 p-x-3">
                <ul className="faux-list-new">
                  {features.map((feature) => {
                    const { href, iconFill } = feature;

                    return (
                      <li key={feature.id}>
                        <Button onClick={() => handleCreateClick(feature.id, href)} classes={linkClass} faux>
                          <IconWithText name={feature.iconName} fill={iconFill} size="m">{feature.title}</IconWithText>
                        </Button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          }}
        </MediaQuery>
      </MaxWidthContainer>
    </div>
  );
};

TopLevelHero.propTypes = {
  pageId: PropTypes.string.isRequired,
  handleCreateClick: PropTypes.func,
};

export default TopLevelHero;



// WEBPACK FOOTER //
// ./library/app/components/Global/Heros/TopLevelHero.js